// @flow

import type {ApplicationState} from '../../types'
import type {MapState} from '../types'

export function getCities(appState: ApplicationState): City[]{
  return _getCities(appState.map) 
}

function _getCities(state: MapState): City[]{
  return state.cities.sort((c1, c2) => {
    if (c1.name < c2.name) return -1
    if (c1.name > c2.name) return 1
    return 0
  })
}

getCities.internal = _getCities
